export const selectors = {
  pagination: (state) => state.notes.pagination,
};
